/**
 * Couldn't find the gift card.
 */
export class GiftCardNotFoundWixError extends Error {
  /** @hidden */
  httpCode: number;
  /** @hidden */
  statusCode: string;
  /** @hidden */
  applicationCode: string;
  /** @hidden */
  name: string;
  /** @hidden */
  errorType: string;
  /** @hidden */
  spiErrorData: object;

  constructor() {
    super('GiftCardNotFound');

    this.httpCode = 404;
    this.statusCode = 'NOT_FOUND';
    this.applicationCode = 'GIFT_CARD_NOT_FOUND';
    this.name = 'GiftCardNotFound';
    this.errorType = 'SPI';
    this.spiErrorData = {
      name: 'GiftCardNotFound',
      applicationCode: 'GIFT_CARD_NOT_FOUND',
    };
  }

  /** @hidden */
  static readonly __type = 'wix_spi_error';
}

/**
 * Gift card is disabled.
 */
export class GiftCardDisabledWixError extends Error {
  /** @hidden */
  httpCode: number;
  /** @hidden */
  statusCode: string;
  /** @hidden */
  applicationCode: string;
  /** @hidden */
  name: string;
  /** @hidden */
  errorType: string;
  /** @hidden */
  spiErrorData: object;

  constructor() {
    super('GiftCardDisabled');

    this.httpCode = 428;
    this.statusCode = 'FAILED_PRECONDITION';
    this.applicationCode = 'GIFT_CARD_DISABLED';
    this.name = 'GiftCardDisabled';
    this.errorType = 'SPI';
    this.spiErrorData = {
      name: 'GiftCardDisabled',
      applicationCode: 'GIFT_CARD_DISABLED',
    };
  }

  /** @hidden */
  static readonly __type = 'wix_spi_error';
}

/**
 * Gift card has expired.
 */
export class GiftCardExpiredWixError extends Error {
  /** @hidden */
  httpCode: number;
  /** @hidden */
  statusCode: string;
  /** @hidden */
  applicationCode: string;
  /** @hidden */
  name: string;
  /** @hidden */
  errorType: string;
  /** @hidden */
  spiErrorData: object;

  constructor() {
    super('GiftCardExpired');

    this.httpCode = 428;
    this.statusCode = 'FAILED_PRECONDITION';
    this.applicationCode = 'GIFT_CARD_EXPIRED';
    this.name = 'GiftCardExpired';
    this.errorType = 'SPI';
    this.spiErrorData = {
      name: 'GiftCardExpired',
      applicationCode: 'GIFT_CARD_EXPIRED',
    };
  }

  /** @hidden */
  static readonly __type = 'wix_spi_error';
}

/**
 * Gift card currency is missing.
 */
export class MissingCurrencyWixError extends Error {
  /** @hidden */
  httpCode: number;
  /** @hidden */
  statusCode: string;
  /** @hidden */
  applicationCode: string;
  /** @hidden */
  name: string;
  /** @hidden */
  errorType: string;
  /** @hidden */
  spiErrorData: object;

  constructor() {
    super('MissingCurrency');

    this.httpCode = 428;
    this.statusCode = 'FAILED_PRECONDITION';
    this.applicationCode = 'MISSING_CURRENCY';
    this.name = 'MissingCurrency';
    this.errorType = 'SPI';
    this.spiErrorData = {
      name: 'MissingCurrency',
      applicationCode: 'MISSING_CURRENCY',
    };
  }

  /** @hidden */
  static readonly __type = 'wix_spi_error';
}

/**
 * Gift card doesn't have enough funds.
 */
export class InsufficientFundsWixError extends Error {
  /** @hidden */
  httpCode: number;
  /** @hidden */
  statusCode: string;
  /** @hidden */
  applicationCode: string;
  /** @hidden */
  name: string;
  /** @hidden */
  errorType: string;
  /** @hidden */
  spiErrorData: object;

  constructor() {
    super('InsufficientFunds');

    this.httpCode = 428;
    this.statusCode = 'FAILED_PRECONDITION';
    this.applicationCode = 'INSUFFICIENT_FUNDS';
    this.name = 'InsufficientFunds';
    this.errorType = 'SPI';
    this.spiErrorData = {
      name: 'InsufficientFunds',
      applicationCode: 'INSUFFICIENT_FUNDS',
    };
  }

  /** @hidden */
  static readonly __type = 'wix_spi_error';
}

/**
 * Gift card was already redeemed for this order.
 */
export class AlreadyRedeemedWixError extends Error {
  /** @hidden */
  httpCode: number;
  /** @hidden */
  statusCode: string;
  /** @hidden */
  applicationCode: string;
  /** @hidden */
  name: string;
  /** @hidden */
  errorType: string;
  /** @hidden */
  spiErrorData: object;

  constructor() {
    super('AlreadyRedeemed');

    this.httpCode = 409;
    this.statusCode = 'ALREADY_EXISTS';
    this.applicationCode = 'ALREADY_REDEEMED';
    this.name = 'AlreadyRedeemed';
    this.errorType = 'SPI';
    this.spiErrorData = {
      name: 'AlreadyRedeemed',
      applicationCode: 'ALREADY_REDEEMED',
    };
  }

  /** @hidden */
  static readonly __type = 'wix_spi_error';
}

/**
 * Currency code isn't supported.
 */
export class CurrencyNotSupportedWixError extends Error {
  /** @hidden */
  httpCode: number;
  /** @hidden */
  statusCode: string;
  /** @hidden */
  applicationCode: string;
  /** @hidden */
  name: string;
  /** @hidden */
  errorType: string;
  /** @hidden */
  spiErrorData: object;

  constructor() {
    super('CurrencyNotSupported');

    this.httpCode = 400;
    this.statusCode = 'INVALID_ARGUMENT';
    this.applicationCode = 'CURRENCY_NOT_SUPPORTED';
    this.name = 'CurrencyNotSupported';
    this.errorType = 'SPI';
    this.spiErrorData = {
      name: 'CurrencyNotSupported',
      applicationCode: 'CURRENCY_NOT_SUPPORTED',
    };
  }

  /** @hidden */
  static readonly __type = 'wix_spi_error';
}

/**
 * Couldn't find the transaction.
 */
export class TransactionNotFoundWixError extends Error {
  /** @hidden */
  httpCode: number;
  /** @hidden */
  statusCode: string;
  /** @hidden */
  applicationCode: string;
  /** @hidden */
  name: string;
  /** @hidden */
  errorType: string;
  /** @hidden */
  spiErrorData: object;

  constructor() {
    super('TransactionNotFound');

    this.httpCode = 404;
    this.statusCode = 'NOT_FOUND';
    this.applicationCode = 'TRANSACTION_NOT_FOUND';
    this.name = 'TransactionNotFound';
    this.errorType = 'SPI';
    this.spiErrorData = {
      name: 'TransactionNotFound',
      applicationCode: 'TRANSACTION_NOT_FOUND',
    };
  }

  /** @hidden */
  static readonly __type = 'wix_spi_error';
}

/**
 * Transaction was already voided.
 */
export class AlreadyVoidedWixError extends Error {
  /** @hidden */
  httpCode: number;
  /** @hidden */
  statusCode: string;
  /** @hidden */
  applicationCode: string;
  /** @hidden */
  name: string;
  /** @hidden */
  errorType: string;
  /** @hidden */
  spiErrorData: object;

  constructor() {
    super('AlreadyVoided');

    this.httpCode = 409;
    this.statusCode = 'ALREADY_EXISTS';
    this.applicationCode = 'ALREADY_VOIDED';
    this.name = 'AlreadyVoided';
    this.errorType = 'SPI';
    this.spiErrorData = {
      name: 'AlreadyVoided',
      applicationCode: 'ALREADY_VOIDED',
    };
  }

  /** @hidden */
  static readonly __type = 'wix_spi_error';
}
